import React from "react";
import { useModalSubscriptionCounterHook } from "./modal-subscription-counter-hooks";

type ContextModalSubscriptionCancel = ReturnType<
  typeof useModalSubscriptionCounterHook
>;
export const ModalSubscriptionCounterContext =
  React.createContext<ContextModalSubscriptionCancel | null>(null);

export function useContextModalSubscriptionCounter() {
  const context = React.useContext(ModalSubscriptionCounterContext);

  if (!context) {
    throw new Error(
      "useContextModalSubscriptionCounter must be used within a ContextModalSubscriptionCounterProvider",
    );
  }

  return context;
}
